import { JSX, useEffect } from 'react';
import { NokMini } from "../../../../types/entities";
import {
    useRecordContext
} from 'react-admin';
import { DefaultAdminUserMiniManagement } from "./DefaultAdminUserMiniManagement";
import { EmailFinderContainer } from "./email-finder/EmailFinderContainer";
import { MysteryShopperContainer } from "./mystery-shopper/MysteryShopperContainer";
import { ComplianceSnifferContainer } from "./compliance-sniffer/ComplianceSnifferContainer";

export const MiniManagementContainer: (props: any) => JSX.Element = (props: any): JSX.Element => {
    const record: NokMini = useRecordContext();

    // A mini with no entry here renders the warning triangle, which is what Compliance Sniffer
    // showed until 2026-09-11: "Use of this mini is currently unavailable!". That was accurate -
    // there was no admin half - and it is not any more.
    const miniManagedList = {
        'email_finder': <EmailFinderContainer />,
        'mystery_shopper': <MysteryShopperContainer />,
        'compliance_sniffer': <ComplianceSnifferContainer />,
    }

    useEffect( (): void => {
        if (record?.name && props?.miniName === "") {
            props.handleSetMiniName(record.name)
        }
    }, [props, record] );

    return (
        <>
            { miniManagedList[record?.systemCode] ?? <DefaultAdminUserMiniManagement  /> }
        </>
    );

}